export class PreviewParameters {

	static CONSTANT_MAX_DISPLAY_SHIFT_VALUE: number = 100;
	static CONSTANT_MIN_VIDEO_RESOLUTION: number = 150;
	static CONSTANT_MAX_VIDEO_RESOLUTION: number = 4000;

	zoom: number;
	verticalShift: number;
	horizontalShift: number;

	displayVerticalShift: number;
	displayHorizontalShift: number;

	customVerticalPadding: number;
	customHorizontalPadding: number;

	maxVerticalShift: number;
	maxHorizontalShift: number;
	defaultVerticalShift: number;
	defaultHorizontalShift: number;
	stepVerticalShift: number;
	stepHorizontalShift: number;

	displayMaxVerticalShift: number;
	displayMaxHorizontalShift: number;
	displayMinVerticalShift: number;
	displayMinHorizontalShift: number;

	minZoom: number;
	maxZoom: number;

	outerVideoResolutionX: number;
	outerVideoResolutionY: number;
	userOuterVideoResolutionsDifference: number;

	top: number;
	left: number;
	width: number;
	height: number;

	constructor() {
		this.zoom = 100;
		this.displayVerticalShift = 0;
		this.displayHorizontalShift = 0;

		this.verticalShift = 0;
		this.horizontalShift = 0;

		this.customVerticalPadding = 0;
		this.customHorizontalPadding = 0;

		this.maxVerticalShift = 0;
		this.maxHorizontalShift = 0;
		this.defaultVerticalShift = 0;
		this.defaultHorizontalShift = 0;
		this.stepVerticalShift = 0;
		this.stepHorizontalShift = 0;

		this.displayMaxVerticalShift = 0;
		this.displayMaxHorizontalShift = 0;
		this.displayMinVerticalShift = 0;
		this.displayMinHorizontalShift = 0;

		this.minZoom = 10;
		this.maxZoom = 200;

		this.outerVideoResolutionX = 0;
		this.outerVideoResolutionY = 0;
		this.userOuterVideoResolutionsDifference = 1;

		this.top = null;
		this.left = null;
		this.width = 100;
		this.height = 100;
	}

	copy(): PreviewParameters {
		let copy = new PreviewParameters;

		copy.zoom = this.zoom;
		copy.displayVerticalShift = this.displayVerticalShift;
		copy.displayHorizontalShift = this.displayHorizontalShift;

		copy.customVerticalPadding = this.customVerticalPadding;
		copy.customHorizontalPadding = this.customHorizontalPadding;

		copy.verticalShift = this.verticalShift;
		copy.horizontalShift = this.horizontalShift;

		copy.maxVerticalShift = this.maxVerticalShift;
		copy.maxHorizontalShift = this.maxHorizontalShift;
		copy.defaultVerticalShift = this.defaultVerticalShift;
		copy.defaultHorizontalShift = this.defaultHorizontalShift;
		copy.stepVerticalShift = this.stepVerticalShift;
		copy.stepHorizontalShift = this.stepHorizontalShift;

		copy.displayMaxVerticalShift = this.displayMaxVerticalShift;
		copy.displayMaxHorizontalShift = this.displayMaxHorizontalShift;
		copy.displayMinVerticalShift = this.displayMinVerticalShift;
		copy.displayMinHorizontalShift = this.displayMinHorizontalShift;

		copy.minZoom = this.minZoom;
		copy.maxZoom = this.maxZoom;

		copy.outerVideoResolutionX = this.outerVideoResolutionX;
		copy.outerVideoResolutionY = this.outerVideoResolutionY;
		copy.userOuterVideoResolutionsDifference = this.userOuterVideoResolutionsDifference;

		copy.top = this.top;
		copy.left = this.left;
		copy.width = this.width;
		copy.height = this.height;

		return copy;
	}

	static copyFromParsed(parsedObject): PreviewParameters {
		let copy = new PreviewParameters;

		copy.zoom = parsedObject.zoom;
		copy.displayVerticalShift = parsedObject.displayVerticalShift;
		copy.displayHorizontalShift = parsedObject.displayHorizontalShift;

		copy.customVerticalPadding = parsedObject.customVerticalPadding ? parsedObject.customVerticalPadding : 0;
		copy.customHorizontalPadding = parsedObject.customHorizontalPadding ? parsedObject.customHorizontalPadding : 0;

		copy.verticalShift = parsedObject.verticalShift;
		copy.horizontalShift = parsedObject.horizontalShift;

		copy.maxVerticalShift = parsedObject.maxVerticalShift;
		copy.maxHorizontalShift = parsedObject.maxHorizontalShift;
		copy.defaultVerticalShift = parsedObject.defaultVerticalShift;
		copy.defaultHorizontalShift = parsedObject.defaultHorizontalShift;
		copy.stepVerticalShift = parsedObject.stepVerticalShift;
		copy.stepHorizontalShift = parsedObject.stepHorizontalShift;

		copy.displayMaxVerticalShift = parsedObject.displayMaxVerticalShift;
		copy.displayMaxHorizontalShift = parsedObject.displayMaxHorizontalShift;
		copy.displayMinVerticalShift = parsedObject.displayMinVerticalShift;
		copy.displayMinHorizontalShift = parsedObject.displayMinHorizontalShift;

		copy.minZoom = parsedObject.minZoom;
		copy.maxZoom = parsedObject.maxZoom;

		copy.outerVideoResolutionX = parsedObject.outerVideoResolutionX;
		copy.outerVideoResolutionY = parsedObject.outerVideoResolutionY;
		copy.userOuterVideoResolutionsDifference = parsedObject.userOuterVideoResolutionsDifference ? parsedObject.userOuterVideoResolutionsDifference : 1;

		copy.top = parsedObject.top;
		copy.left = parsedObject.left;
		copy.width = parsedObject.width;
		copy.height = parsedObject.height;

		return copy;
	}

	checkAndUpdateUserOuterVideoResolutions() {
		if (this.userOuterVideoResolutionsDifference === 1) {
			return;
		}
		let minVideoResolution = PreviewParameters.CONSTANT_MIN_VIDEO_RESOLUTION;
		let maxVideoResolution = PreviewParameters.CONSTANT_MAX_VIDEO_RESOLUTION;
		if (
			this.outerVideoResolutionX *
			this.userOuterVideoResolutionsDifference <
			minVideoResolution
		) {
			this.userOuterVideoResolutionsDifference =
				minVideoResolution /
				this.outerVideoResolutionX;
		} else if (
			this.outerVideoResolutionY *
			this.userOuterVideoResolutionsDifference <
			minVideoResolution
		) {
			this.userOuterVideoResolutionsDifference =
				minVideoResolution /
				this.outerVideoResolutionY;
		}
		if (
			this.outerVideoResolutionX *
			this.userOuterVideoResolutionsDifference >
			maxVideoResolution
		) {
			this.userOuterVideoResolutionsDifference =
				maxVideoResolution /
				this.outerVideoResolutionX;
		} else if (
			this.outerVideoResolutionY *
			this.userOuterVideoResolutionsDifference >
			maxVideoResolution
		) {
			this.userOuterVideoResolutionsDifference =
				maxVideoResolution /
				this.outerVideoResolutionY;
		}
	}
}